<template>
  <BaseCopy
    :size="size"
    v-bind="$attrs"
  >
    <slot />
  </BaseCopy>
</template>

<script>
export default {
  name: 'BodyCopy',

  props: {
    small: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    size () {
      return this.small ? 'body-sm' : 'body'
    }
  }
}
</script>

<style>

</style>
